module.exports = __webpack_public_path__ + "img/coupon-h5-clean.d53f2fe1.png";